import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function CancelCircleIcon({
  className,
  fill = IconColors.DarkGrey,
  height = 18,
  width = 18,
}: SimpleIconInterface) {
  return (
    <SimpleIcon
      className={className}
      fill="none"
      height={height}
      viewBoxDimensions="0 0 14 15"
      width={width}
    >
      <path
        d="M9.48425 5.57366L7.74616 7.31105L9.48425 9.04845C9.77165 9.33584 9.64015 9.82658 9.24756 9.93177C9.06536 9.98059 8.87095 9.9285 8.73757 9.79512L7.00014 8.05707L5.26271 9.79512C4.97531 10.0825 4.48457 9.95103 4.37938 9.55844C4.33055 9.37624 4.38265 9.18183 4.51602 9.04845L6.25411 7.31105L4.51602 5.57366C4.22863 5.28626 4.36012 4.79553 4.75272 4.69034C4.93492 4.64151 5.12933 4.69361 5.26271 4.82698L7.00014 6.56504L8.73757 4.82698C9.02496 4.53959 9.51571 4.67108 9.6209 5.06367C9.66972 5.24587 9.61763 5.44028 9.48425 5.57366ZM13.8601 7.31105C13.8601 12.5918 8.14347 15.8923 3.57014 13.2519C-1.0032 10.6115 -1.0032 4.01059 3.57014 1.37022C4.61299 0.768141 5.79596 0.451172 7.00014 0.451172C10.7872 0.455175 13.8561 3.5241 13.8601 7.31105ZM12.8048 7.31105C12.8048 2.84274 7.96758 0.050035 4.09783 2.28419C0.228086 4.51835 0.228086 10.1038 4.09783 12.3379C4.98017 12.8473 5.9813 13.1155 7.00014 13.1156C10.2044 13.1119 12.8011 10.5153 12.8048 7.31105Z"
        fill={fill}
      />
    </SimpleIcon>
  );
}
